var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#38A0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 19L19.19 16L14 13V19ZM25.56 11.17C25.69 11.64 25.78 12.27 25.84 13.07C25.91 13.87 25.94 14.56 25.94 15.16L26 16C26 18.19 25.84 19.8 25.56 20.83C25.31 21.73 24.73 22.31 23.83 22.56C23.36 22.69 22.5 22.78 21.18 22.84C19.88 22.91 18.69 22.94 17.59 22.94L16 23C11.81 23 9.2 22.84 8.17 22.56C7.27 22.31 6.69 21.73 6.44 20.83C6.31 20.36 6.22 19.73 6.16 18.93C6.09 18.13 6.06 17.44 6.06 16.84L6 16C6 13.81 6.16 12.2 6.44 11.17C6.69 10.27 7.27 9.69 8.17 9.44C8.64 9.31 9.5 9.22 10.82 9.16C12.12 9.09 13.31 9.06 14.41 9.06L16 9C20.19 9 22.8 9.16 23.83 9.44C24.73 9.69 25.31 10.27 25.56 11.17Z",
    fill: "#0D1A30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogo);
export default __webpack_public_path__ + "static/media/youtube-logo.98f2c4d435f9d2000fb602f6fafdee4e.svg";
export { ForwardRef as ReactComponent };